import http from '../plugins/axios'
import { mutationUserForceDelete } from './graphql/mutations/user/userForceDelete.mutation'
import { mutationUserGenerateSignature } from './graphql/mutations/user/userGenerateSignature.mutation'
import { queryGetUserProductRecommendation } from './graphql/queries/userProductRecommendation.queries'
import { queryGetUserSignature } from './graphql/queries/userSignature.queries'

let detailUserCache = {};

export const clearDetailUserCache = () => {
  detailUserCache = {};
};

export const getListUsers = async (params) => {
  try {
    const response = await http.get(`/api/v2/users`, { params })
    return response
  } catch (error) {
    throw error
  }
}
export const getListUsersInactive = async (params) => {
  try {
    const response = await http.get(`/api/v2/users/inactive`, { params })
    return response
  } catch (error) {
    throw error
  }
}

export const getListUserChildables = async (userId, params) => {
  try {
    const response = await http.get(`/api/v2/users/childables/${userId}`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateUser = async (userId, payload) => {
  try {
    const response = await http.put(`/api/v2/users/${userId}`, payload)
    clearDetailUserCache()
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDetailUser = async (userId, params) => {
  const cacheKey = `${userId}_${params ? JSON.stringify(params) : '{}'}`;
  const cached = detailUserCache[cacheKey];

  // Cache user details for 5 minutes (300000ms)
  if (cached && (Date.now() - cached.timestamp < 300000)) {
    return cached.data;
  }

  try {
    const response = await http.get(`/api/v2/users/${userId}`, { params })
    detailUserCache[cacheKey] = {
      data: response.data,
      timestamp: Date.now()
    };
    return response.data
  } catch (error) {
    throw error
  }
}

export const getListUserMemberships = async (params) => {
  try {
    const response = await http.get(`/api/v2/memberships`, { params })
    return response
  } catch (error) {
    throw error
  }
}

export const updateMembership = async (membershipId, payload) => {
  try {
    const response = await http.put(`/api/v2/memberships/${membershipId}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getListUserExcludeAdmin = async (params) => {
  try {
    const response = await http.get(`api/v2/users/excludeadmin`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const addPhotoProfile = async (userId, payload) => {
  try {
    const response = await http.post(`api/v2/users/${userId}/photo-profile`, payload)
    clearDetailUserCache()
    return response.data
  } catch (error) {
    throw error
  }
}

export const updatePhotoProfile = async (userId, payload) => {
  try {
    const response = await http.put(`api/v2/users/${userId}/photo-profile`, payload)
    clearDetailUserCache()
    return response.data
  } catch (error) {
    throw error
  }
}

export const deletePhotoProfile = async (userId) => {
  try {
    const response = await http.delete(`api/v2/users/${userId}/photo-profile`)
    clearDetailUserCache()
    return response.data
  } catch (error) {
    throw error
  }
}

// user product recommendation
export const getUserProductRecommendations = async (variables) => {
  try {
    const response = await http.post(`/graphql`, {
      query: queryGetUserProductRecommendation,
      variables,
    })
    return response
  } catch (error) {
    throw error
  }
}

export const addProductRecommendation = async (userId, payload) => {
  try {
    const response = await http.post(`api/v2/users/${userId}/recommend`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteUserProductRecommendation = async (userId, productId) => {
  try {
    const response = await http.delete(`api/v2/products/${productId}/recommend/${userId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const setOnlineStatusUser = async (payload) => {
  try {
    const response = await http.post('api/v2/user/set-status', payload)
    return response.data
  } catch (error) {
    throw error
  }
}

// restore user
export const restoreUser = async (payload) => {
  try {
    const response = await http.post(`api/v2/users/restore`, payload)
    clearDetailUserCache()
    return response.data
  } catch (error) {
    throw error
  }
}

// delete user
export const deleteUser = async (userId) => {
  try {
    const response = await http.delete(`/api/v2/users/${userId}`)
    clearDetailUserCache()
    return response.data
  } catch (error) {
    throw error
  }
}

// permanent delete user
export const deletUserPermanent = async (variables) => {
  try {
    const response = await http.post(`/graphql`, {
      query: mutationUserForceDelete,
      variables,
    })
    console.log(response)
    if (!response.data.errors) {
      clearDetailUserCache()
      return { success: true }
    } else {
      throw new Error("Something went wrong!");
    }
  } catch (error) {
    throw error
  }
}

// create user
export const createUser = async (payload) => {
  try {
    const response = await http.post(`/api/v2/users`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateUserDocumentVerification = async (userId, payload) => {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  try {
    const response = await http.post(`/api/v2/users/${userId}/document-verification`, payload, config)
    return response.data
  } catch (error) {
    throw error
  }
}

export const addUserRelation = async (payload) => {
  try {
    const response = await http.post(`/api/v2/users/user-relations`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteUserRelation = async (relationId) => {
  try {
    const response = await http.delete(`/api/v2/users/user-relations/${relationId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getListUserOrdersHistory = async (params) => {
  try {
    const response = await http.get(`/api/v2/orders/admin`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getListUserPoint = async (userId, params) => {
  try {
    const response = await http.get(`/api/v2/users/${userId}/point`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const addUserPoint = async (userId, payload) => {
  try {
    const response = await http.post(`/api/v2/users/${userId}/point`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateUserPoint = async (userId, pointId, payload) => {
  try {
    const response = await http.put(`/api/v2/users/${userId}/point/${pointId}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteUserPoint = async (userId, pointId) => {
  try {
    const response = await http.delete(`/api/v2/users/${userId}/point/${pointId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

export const submitUserCompany = async (companyId, payload) => {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  try {
    const response = await http.post(`/api/v2/companies${companyId !== null ? `/${companyId}` : ''}`, payload, config)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getListCommisionUser = async (params) => {
  try {
    const response = await http.get(`/api/v2/payout-commision`, { params })
    return response.data
  } catch (error) {
    throw error
  }
}

export const addCommisionUser = async (payload) => {
  try {
    const response = await http.post(`/api/v2/payout-commision`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const updateCommisionUser = async (commisionId, payload) => {
  try {
    const response = await http.put(`/api/v2/payout-commision/${commisionId}`, payload)
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteCommisionUser = async (commisionId) => {
  try {
    const response = await http.delete(`/api/v2/payout-commision/${commisionId}`)
    return response.data
  } catch (error) {
    throw error
  }
}

// signature for product recommendation
export const getUserSignature = async (userId) => {
  try {
    const response = await http.post(`/graphql`, {
      query: queryGetUserSignature,
      variables: { userId },
    })
    return response
  } catch (error) {
    throw error
  }
}
export const generateUserSignature = async (userId) => {
  try {
    const response = await http.post(`/graphql`, {
      query: mutationUserGenerateSignature,
      variables: { userId },
    })
    return response
  } catch (error) {
    throw error
  }
}